class UltraCollection {
  constructor(sectionId) {
    this.container = document.getElementById(sectionId);
    if (!this.container) return;

    this.sectionId = sectionId.replace('ultra-', ''); // Extract original ID
    this.grid = document.getElementById('ProductGrid');
    this.loader = document.getElementById('InfiniteLoader');
    this.filterWrapper = this.container.querySelector('.ultra-col__filter-wrapper');
    this.activeCategory = sessionStorage.getItem('ultraColActiveCategory') || 'all';
    this.isLoading = false;

    this.initSmartSwipeForCards(); 
    this.initInfiniteScroll();
    // this.initToastListener(); <--- Removed: Handled by Dawn native product-form.js
    this.initFilterListeners();
    this.hideSingleValueFilters(); 
    this.restoreFilterState(); 
    
    if (!window.ultraCollectionPopstateBound) {
       window.addEventListener('popstate', () => {
         this.fetchSection(window.location.href);
       });
       window.ultraCollectionPopstateBound = true;
    }

    if (this.grid && this.grid.children.length === 0 && this.loader) {
      this.loadNextPage();
    }
  }

  initFilterListeners() {
    if (!this.filterWrapper) return;

    // 1. Category Click (Toggle Drawer)
    this.filterWrapper.addEventListener('click', (e) => {
        const catBtn = e.target.closest('.ultra-col__cat-btn');
        if (catBtn) {
            e.preventDefault();
            
            // Handle "All" separately
            if (catBtn.dataset.group === 'all') {
                const url = catBtn.dataset.url;
                this.setActiveCategory('all');
                if (url) this.updatePage(url);
                return;
            }

            // Toggle active state
            const groupName = catBtn.dataset.group;
            if (catBtn.classList.contains('active')) {
                // If clicking active, maybe close it? Or do nothing?
                // UX decision: Clicking active closes drawer (toggle)
                this.setActiveCategory('all'); 
            } else {
                this.setActiveCategory(groupName);
            }
        }
    });

    // 2. Value Click (AJAX Fetch)
    this.filterWrapper.addEventListener('click', (e) => {
        const valLink = e.target.closest('.ultra-col__val-pill');
        if (valLink) {
            e.preventDefault();
            this.updatePage(valLink.href);
        }
    });
  }

  setActiveCategory(groupName) {
      this.activeCategory = groupName;
      sessionStorage.setItem('ultraColActiveCategory', groupName);
      this.restoreFilterState();
  }

  restoreFilterState() {
      if (!this.filterWrapper) return;
      
      const allBtns = this.filterWrapper.querySelectorAll('.ultra-col__cat-btn');
      const allGroups = this.filterWrapper.querySelectorAll('.ultra-col__value-group');

      // Reset
      allBtns.forEach(btn => btn.classList.remove('active'));
      allGroups.forEach(g => g.hidden = true);

      // Activate
      if (this.activeCategory === 'all') {
          const allBtn = this.filterWrapper.querySelector('[data-group="all"]');
          if (allBtn) allBtn.classList.add('active');
      } else {
          const targetBtn = this.filterWrapper.querySelector(`[data-group="${this.activeCategory}"]`);
          const targetGroup = this.filterWrapper.querySelector(`#group-${this.activeCategory}`);
          
          if (targetBtn && targetBtn.style.display !== 'none') {
             targetBtn.classList.add('active');
             if (targetGroup) targetGroup.hidden = false;
          } else {
             // Fallback if active category was hidden or doesn't exist
             const allBtn = this.filterWrapper.querySelector('[data-group="all"]');
             if (allBtn) allBtn.classList.add('active');
          }
      }
  }

  hideSingleValueFilters() {
    if (!this.filterWrapper) return;
    
    const groups = this.filterWrapper.querySelectorAll('.ultra-col__value-group');
    groups.forEach(group => {
       const count = group.querySelectorAll('.ultra-col__val-pill').length;
       const handle = group.id.replace('group-', '');
       const btn = this.filterWrapper.querySelector(`.ultra-col__cat-btn[data-group="${handle}"]`);
       
       if (btn) {
           if (count <= 1) {
               btn.style.display = 'none';
               // If we are hiding the currently active category, reset to 'all'
               if (this.activeCategory === handle) {
                   this.activeCategory = 'all';
                   sessionStorage.setItem('ultraColActiveCategory', 'all');
               }
           } else {
               btn.style.display = '';
           }
       }
    });
  }

  updatePage(url) {
      window.history.pushState({ path: url }, '', url);
      this.fetchSection(url);
  }

  fetchSection(url) {
    if (this.grid) this.grid.classList.add('loading');
    
    // --- CRITICAL PERFORMANCE FIX ---
    // Append section_id to fetch ONLY the section HTML, not the full page.
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', this.sectionId);

    fetch(fetchUrl)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.renderSection(html);
      })
      .catch(e => console.error(e));
  }

  renderSection(html) {
    const newGrid = html.getElementById('ProductGrid');
    const oldGrid = document.getElementById('ProductGrid');
    if (newGrid && oldGrid) {
      oldGrid.innerHTML = newGrid.innerHTML;
      oldGrid.classList.remove('loading');
    }

    // Update Filter Bar (HTML)
    const newFilters = html.querySelector('.ultra-col__filter-wrapper');
    const oldFilters = this.container.querySelector('.ultra-col__filter-wrapper');
    if (newFilters && oldFilters) {
      oldFilters.innerHTML = newFilters.innerHTML;
      this.hideSingleValueFilters(); // <--- Re-check counts on new HTML
      this.restoreFilterState();
    }

    // Handle Infinite Loader
    const newLoader = html.getElementById('InfiniteLoader');
    const oldLoader = document.getElementById('InfiniteLoader');
    
    if (newLoader && oldLoader) {
      oldLoader.dataset.nextUrl = newLoader.dataset.nextUrl || '';
      oldLoader.classList.remove('hidden');
      if (!newLoader.dataset.nextUrl) oldLoader.remove();
    } else if (newLoader && !oldLoader && newGrid) {
      const gridContainer = document.querySelector('.ultra-col__grid-container');
      gridContainer.appendChild(newLoader);
    } else if (!newLoader && oldLoader) {
      oldLoader.remove();
    }

    this.grid = document.getElementById('ProductGrid');
    this.loader = document.getElementById('InfiniteLoader');
    
    this.initSmartSwipeForCards(); 
    this.initInfiniteScroll();

    if (this.grid && this.grid.children.length === 0 && this.loader) {
      this.loadNextPage();
    }
  }

  // --- START SmartSwipe Engine ---
  initSmartSwipeForCards() {
    const cards = this.container.querySelectorAll('.ultra-col__card');
    cards.forEach(card => this.initCardSwipe(card));
  }

  initCardSwipe(card) {
    if (card.dataset.smartSwipeInit === 'true') return;
    card.dataset.smartSwipeInit = 'true';

    const track = card.querySelector('.ultra-col__slider-track');
    const slides = card.querySelectorAll('.ultra-col__slide');
    if (!track || slides.length <= 1) return;

    // FIX: Ensure track doesn't clip slides so they sit side-by-side
    track.style.overflow = 'visible'; 

    // State
    let currentIndex = 0;
    let startX = 0;
    let startY = 0;
    let isDragging = false;
    let isHorizontalSwipe = false;
    let isDirectionLocked = false;
    let isClickBlocked = false; // <--- Track if drag occurred to block clicks
    let currentTranslate = 0;

    // Helper: Move Slider
    const updateSlide = (index, animate = true) => {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentIndex = index;
        
        const offset = -currentIndex * 100;
        track.style.transition = animate ? 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
        track.style.transform = `translateX(${offset}%)`;
        
        // Update Dots
        const dots = card.querySelectorAll('.ultra-col__dot');
        dots.forEach((d, i) => d.classList.toggle('active', i === currentIndex));
    };

    // --- Touch Events (Mobile/Tablet) ---
    track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        isDirectionLocked = false;
        isHorizontalSwipe = false;
        track.style.transition = 'none'; // Remove transition for 1:1 movement
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = currentX - startX;
        const diffY = currentY - startY;

        // Direction Lock Logic
        if (!isDirectionLocked) {
            if (Math.abs(diffX) > 10 || Math.abs(diffY) > 10) {
                isDirectionLocked = true;
                if (Math.abs(diffX) > Math.abs(diffY)) {
                    isHorizontalSwipe = true;
                }
            }
        }

        if (isHorizontalSwipe) {
            if (e.cancelable) e.preventDefault(); // Stop Page Scroll
            e.stopPropagation();
            
            // 1:1 Movement logic
            const slideWidth = track.offsetWidth;
            const currentOffset = -currentIndex * slideWidth;
            const newOffset = currentOffset + diffX;
            track.style.transform = `translateX(${newOffset}px)`;
        }
    }, { passive: false });

    track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;

        if (isHorizontalSwipe) {
            const endX = e.changedTouches[0].clientX;
            const diffX = endX - startX;
            const threshold = 50;

            if (diffX > threshold) {
                updateSlide(currentIndex - 1);
            } else if (diffX < -threshold) {
                updateSlide(currentIndex + 1);
            } else {
                updateSlide(currentIndex);
            }
            e.stopPropagation();
        } else {
            // Revert any slight drags
            updateSlide(currentIndex);
        }
    }, { passive: true });

    // --- Mouse Events (Desktop Drag) ---
    track.addEventListener('mousedown', (e) => {
        e.preventDefault(); // Prevent image drag
        startX = e.clientX;
        isDragging = true;
        isDirectionLocked = true; // Always horizontal on mouse
        isHorizontalSwipe = true;
        isClickBlocked = false; // Reset click block status
        track.style.transition = 'none';
    });

    track.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        
        const diffX = e.clientX - startX;
        
        // If dragged more than 5px, mark as a drag (not a click)
        if (Math.abs(diffX) > 5) {
            isClickBlocked = true;
        }

        const slideWidth = track.offsetWidth;
        const currentOffset = -currentIndex * slideWidth;
        track.style.transform = `translateX(${currentOffset + diffX}px)`;
    });

    const endDrag = (e) => {
        if (!isDragging) return;
        isDragging = false;
        const diffX = e.clientX - startX;
        const threshold = 50;
        
        if (diffX > threshold) updateSlide(currentIndex - 1);
        else if (diffX < -threshold) updateSlide(currentIndex + 1);
        else updateSlide(currentIndex);
    };

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    // --- Click Interceptor ---
    // This catches the click event that fires after mouseup and blocks it if we dragged.
    track.addEventListener('click', (e) => {
        if (isClickBlocked) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, { capture: true });

    // --- Arrow Click Events ---
    const arrows = card.querySelectorAll('.ultra-col__arrow');
    arrows.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const dir = btn.classList.contains('next') ? 1 : -1;
            updateSlide(currentIndex + dir);
        });
    });

    // --- Dots Click Events ---
    const dots = card.querySelectorAll('.ultra-col__dot');
    dots.forEach((dot, i) => {
        dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            updateSlide(i);
        });
    });
  }
  // --- END SmartSwipe Engine ---

  initInfiniteScroll() {
    if (!this.loader || !this.grid) return;
    if (this.observer) this.observer.disconnect();

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.isLoading) {
        this.loadNextPage();
      }
    }, { rootMargin: '400px' });

    this.observer.observe(this.loader);
  }

  loadNextPage() {
    if (this.isLoading) return;
    const nextUrl = this.loader.dataset.nextUrl;
    if (!nextUrl) return;

    this.isLoading = true;
    this.loader.classList.add('visible');

    // Optimization: Add section_id here too
    const fetchUrl = new URL(nextUrl, window.location.origin);
    fetchUrl.searchParams.set('section_id', this.sectionId);

    fetch(fetchUrl)
      .then(r => r.text())
      .then(data => {
        const parser = new DOMParser(); 
        const doc = parser.parseFromString(data, 'text/html');
        const newItems = doc.querySelectorAll('.ultra-col__card');
        const newNext = doc.getElementById('InfiniteLoader');
        
        let addedCount = 0;
        newItems.forEach(item => {
          this.grid.appendChild(item);
          addedCount++;
        });
        
        this.initSmartSwipeForCards(); // Re-init for newly loaded items

        if (newNext && newNext.dataset.nextUrl) { 
          this.loader.dataset.nextUrl = newNext.dataset.nextUrl; 
          this.loader.classList.remove('visible'); 
          
          if (addedCount === 0) {
             this.isLoading = false;
             this.loadNextPage();
             return;
          }
        } else { 
          this.loader.remove(); 
        }
        
        this.isLoading = false;
      })
      .catch(e => {
        console.error("Infinite Scroll Error:", e);
        this.isLoading = false;
      });
  }
}

// Export the class globally so the liquid file can instantiate it
window.UltraCollection = UltraCollection;